'use client';

import { RECENT_POSTS_SEARCH_LABEL } from '@communio/forum-query';
import { brandConfig } from '@/config/brand';

/** Search recent forum posts. Submits to the forum board, which reads `q`. */
export function ChromeSearch() {
  return (
    <form className="chrome-search" role="search" action={brandConfig.forum.path} method="get">
      <label htmlFor="chrome-search-q" className="visually-hidden">
        {RECENT_POSTS_SEARCH_LABEL}
      </label>
      <input
        id="chrome-search-q"
        name="q"
        type="search"
        placeholder={RECENT_POSTS_SEARCH_LABEL}
        autoComplete="off"
      />
    </form>
  );
}
